import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import Link from "shared/Link";
import classNames from "classnames";
import styles from "./IncidentDetails.module.css";

export function IncidentDetails({ details }) {
  return (
    <div className={styles.container}>
      <div className={styles.twoColumn}>
        <div>
          <div>Name</div>
          <div>
            {details.firstName} {details.lastName}
          </div>
        </div>
        <div></div>
      </div>

      <div className={styles.twoColumn}>
        <div>
          <div>IBO #</div>
          <div>
            <Link to={`/security/ibo/${details.iboNumber}`}>
              <div className={styles.link}>{details.iboNumber}</div>
            </Link>
          </div>
        </div>
        <div></div>
      </div>

      <div className={styles.twoColumn}>
        <div>
          <div>Email</div>
          <div>{details.email}</div>
        </div>
        <div></div>
      </div>

      <div className={styles.twoColumn}>
        <div>
          <div>Phone</div>
          <div>{details.phoneNumber}</div>
        </div>
        <div></div>
      </div>

      <div>
        <div>
          <div>Username</div>
          <div>{details.username}</div>
        </div>
      </div>

      <div>
        <div>
          <div>Address</div>
          <div>
            {details.address} {details.city} {details.state} {details.zip}
          </div>
        </div>
      </div>

      <div>
        <div>
          <div>Membership Status</div>
          <div>{details.membershipStatus}</div>
        </div>
      </div>

      <div>
        <div>
          <div>Location</div>
          <div>{details.problemLocation}</div>
        </div>
      </div>

      <div>
        <div>
          <div>Sub-Location</div>
          <div>{details.subLocation}</div>
        </div>
      </div>

      <div>
        <div>
          <div>Start Date</div>
          <div>
            {dayjs(`${details.startDate.month} 
            ${details.startDate.day} 
            ${details.startDate.year}`).format("MM/DD/YY")}
          </div>
        </div>
      </div>

      <div className={styles.twoColumn}>
        <div>
          <div>Upline Involvement</div>
          <div>{details.fromUpline ? "Yes" : "No"}</div>
        </div>
        <div>
          <div>Attempted Resolution</div>
          <div>{details.attemptedResolution ? "Yes" : "No"}</div>
        </div>
      </div>

      <div className={styles.twoColumn}>
        <div>
          <div>Violation of Agreement</div>
          <div>{details.hasViolated ? "Yes" : "No"}</div>
        </div>
        <div className={styles.actionsTakenToResolveContainer}>
          <div>Actions Taken to Resolve</div>
          <div className={styles.actionsTakenToResolve}>
            {details.actionsTakenToResolve}
          </div>
        </div>
      </div>
    </div>
  );
}
